export default "__VITE_ASSET__CDw$aN1L__"